<template>
  <div class="background">
    <v-container fluid fill-height>
      <v-row dense justify="center" align="center">
        <v-col cols="12" sm="8" md="4">
          <v-card
            style="
              background-color: #fcfcfd;
              border-radius: 10px;
              padding: 30px !important;
            "
          >
            <v-card-title
              class="d-flex align-center justify-center loginImages"
            >
              <v-img :src="titleImage" contain height="80"> </v-img>
            </v-card-title>
            <v-card-text elevation="0" class="m-0 p-0">
              <v-stepper v-model="step" elevation="0">
                <v-stepper-content step="1">
                  <v-card-text elevation="0" class="m-0 p-0" v-if="success">
                    <v-row dense align="center" justify="center">
                      <v-img
                        max-width="40"
                        src="@/assets/icons/email.svg"
                      ></v-img>
                    </v-row>
                    <v-row align="center" justify="center">
                      <h3 style="color: #8c1843; font-size: 23px">
                        Email Confirmado!
                      </h3>
                    </v-row>
                    <v-row justify="center" class="mt-10">
                      <span class="body-text-regular">
                        Bem-vindo! Seu email foi validado com sucesso.
                      </span>
                    </v-row>
                    <v-row align="center" justify="center" class="mt-10">
                      <div class="fill-width">
                        <v-btn
                          color="#B51F57"
                          class="white--text fill-width"
                          x-large
                          @click="onClick"
                        >
                          Ir para login
                        </v-btn>
                      </div>
                    </v-row>
                  </v-card-text>
                  <v-card-text
                    elevation="0"
                    class="m-0 p-0"
                    v-if="displayMessage"
                  >
                    <v-row dense align="center" justify="center">
                      <v-img
                        max-width="40"
                        src="@/assets/icons/email.svg"
                      ></v-img>
                    </v-row>
                    <v-row align="center" justify="center">
                      <h3 style="color: #8c1843; font-size: 23px">
                        Link inválido
                      </h3>
                    </v-row>
                    <v-row justify="center" class="mt-10">
                      <span class="body-text-regular">
                        O link informado é inválido ou expirou.
                      </span>
                    </v-row>
                    <v-row align="center" justify="center" class="mt-10">
                      <div class="fill-width">
                        <v-btn
                          color="#B51F57"
                          class="white--text fill-width"
                          x-large
                          @click="returnToHome"
                        >
                          Ir para login
                        </v-btn>
                      </div>
                    </v-row>
                  </v-card-text>
                </v-stepper-content>
                <v-stepper-content step="2">
                  <v-row
                    dense
                    align="center"
                    justify="center"
                    class="pa-0 ma-0"
                  >
                    <div v-if="!validatedOTP">
                      <span>Informe o código recebido no e-mail:</span>
                    </div>
                    <v-otp-input
                      v-if="!validatedOTP"
                      plain
                      v-model="otpValue"
                      length="6"
                      type="password"
                      :disabled="loadingOtp"
                      @finish="onFinishOtp"
                    />
                  </v-row>
                  <v-row
                    dense
                    class="ma-0 pa-0"
                    align="center"
                    justify="center"
                  >
                    <custom-input
                      v-if="validatedOTP"
                      required
                      v-model="newPassword"
                      label="Nova senha"
                      placeholder="Digite a nova senha"
                      :type="showPassword ? 'text' : 'password'"
                      :customRule="rules.password"
                      :currentValue="newPassword"
                      :errorMessage="errorMessage"
                      class="mt-4"
                      :appendIcon="showPassword ? 'mdi-eye' : 'mdi-eye-closed'"
                      @iconClick="showPassword = !showPassword"
                    ></custom-input>
                    <div class="d-flex flex-column fill-width">
                      <v-btn
                        v-if="validatedOTP"
                        color="#B51F57"
                        class="white--text fill-width"
                        x-large
                        @click="submitPasswordChange"
                      >
                        Confirmar
                      </v-btn>
                    </div>
                  </v-row>
                </v-stepper-content>
              </v-stepper>
            </v-card-text>
            <v-card-actions
              class="d-flex align-center justify-center flex-column"
            >
              <div>
                <CopyRight />
              </div>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import CopyRight from "@/components/CopyRight.vue";
import customerApi from "@/shared/pitchCustomerApi";
import partnerApi from "@/shared/pitchPartnerApi";

export default {
  components: {
    CopyRight,
  },
  computed: {
    titleImage() {
      return require("@/assets/images/logo_pitch.png");
    },
  },
  data() {
    return {
      success: false,
      displayMessage: false,
      pwdRegister: false,
      step: 1,
      otpValue: null,
      loadingOtp: false,
      validatedOTP: false,
      newPassword: null,
      errorMessage: null,
      tempPassToken: null,
      showPassword: false,
      currentModule: null,
      rules: {
        password: [
          (v) => !!v || "Campo obrigatório.",
          (v) =>
            /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%*#¢+§])[A-Za-z\d@$!%*#?$§-]{8,}$/.test(
              v
            ) ||
            "Senha deve ter pelo menos 8 caracteres, incluindo pelo menos uma letra maiuscula, um número e um caractere especial",
        ],
      },
    };
  },
  created() {
    if (this.$route.query.module) {
      const { module, key, token } = this.$route.query;
      this.currentModule = module;
      if (token) {
        this.tempPassToken = token;
        this.pwdRegister = true;
      }

      if (module === "aluno") {
        customerApi
          .activateAccount(key)
          .then((res) => {
            if (res.data.success) {
              if (this.pwdRegister) this.step = 2;
              this.success = true;
            } else {
              this.displayMessage = true;
            }
          })
          .catch(() => {
            this.displayMessage = true;
          });
      } else if (module === "professor") {
        partnerApi
          .activateAccount(key)
          .then((res) => {
            if (res.data.success) {
              if (this.pwdRegister) this.step = 2;
              else this.success = true;
            } else {
              this.displayMessage = true;
            }
          })
          .catch(() => {
            this.displayMessage = true;
          });
      } else {
        this.displayMessage = true;
        localStorage.removeItem("module");
      }
    } else this.displayMessage = true;
  },

  methods: {
    onClick() {
      if (!this.pwdRegister) {
        this.returnToHome();
      }
    },
    returnToHome() {
      this.$router.push({
        path: "/connect",
      });
    },

    onFinishOtp() {
      this.loadingOtp = true;
      const request =
        this.currentModule === "aluno"
          ? customerApi.validateOtp(this.otpValue)
          : partnerApi.validateOtp(this.otpValue);

      request
        .then((res) => {
          if (res.data.result) this.validatedOTP = true;
          else
            this.$root.$emit("display-alert", {
              text: "Código OTP inválido, ou expirado.",
              type: 1,
            });
          this.loadingOtp = false;
        })
        .catch(() => {
          this.$root.$emit("display-alert", {
            text: "Código OTP inválido, ou expirado.",
            type: 1,
          });
        });
    },
    submitPasswordChange() {
      const payload = {
        otp: this.otpValue,
        token: this.tempPassToken,
        password: this.newPassword,
      };
      const request =
        this.currentModule === "aluno"
          ? customerApi.updatePassword(payload)
          : partnerApi.updatePassword(payload);

      request
        .then(() => {
          this.$root.$emit("display-message", {
            text: "Senha cadastrada com sucesso!",
            type: 0,
          });
          this.step = 1;
          this.success = true;
          this.displayMessage = false;
          this.pwdRegister = false;
        })
        .catch((err) => {
          this.errorMessage = Array.isArray(err.response.data.message)
            ? err.response.data.message[0]
            : err.response.data.message;
        });
    },
  },
};
</script>
<style scoped>
.background {
  background-image: url("../../assets/images/connect/customer/background-min.webp");
  height: 100vh;
  width: 100vw;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: fixed;
  top: 0;
  left: 0;
}

.primary900 {
  color: #6b1233;
}
</style>
